/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain as AddToCartChain } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { getDataLayer } from "@monsma/App/Utilities/DataLayer";

export const _GaAddProductToCart: any = (props: any) => {
    const state = props.getState();

    if (state && state["xGA"] && state["xGA"]["addToCartEvent"]) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const GAData = {
            name: props.apiResult.shortDescription,
            id: props.apiResult.erpNumber,
            price: props.apiResult.pricing.unitNetPrice,
            quantity: props.apiResult.qtyOrdered,
        } as any;

        if (state["xGA"]["productBrand"]) {
            GAData["brand"] = props.apiResult.brand?.name || "";
        }

        if (state["xGA"]["productCategory"]) {
            GAData["category"] = props.apiResult.properties["category"];
        }

        const data = {
            event: state["xGA"]["addToCartEventName"] || "addToCart",
            ecommerce: {
                currencyCode: state.context.session.currency.currencyCode,
                add: {
                    products: [GAData],
                },
            },
        };

        dataLayer.push(data);
    }
};

addToEndOfChain(AddToCartChain, _GaAddProductToCart);
